import { PushNotifications } from '@capacitor/push-notifications';
import { Capacitor } from '@capacitor/core';
import { useNavigate } from 'react-router-dom';
import useAuth from '../auth/publicUsers/useAuth';
import { pushTokenSaveToken, pushTokenSaveTokenDoctor } from '../crud/PushTokenCrud';

const useRegisterPush = () => {
    const navigate = useNavigate()
    const { authentication } = useAuth()
    const handleRegister = async () => {
        console.log("1. handleRegister start");
        if (!Capacitor.isNativePlatform()) {
            console.log("NOT native platform - yahin ruk gaya");
            return;
        }
        console.log("2. native platform OK");

        const perm = await PushNotifications.requestPermissions();
        console.log("3. permission:", JSON.stringify(perm));
        if (perm.receive !== 'granted') {
            console.log("permission NAHI mili - yahin ruk gaya");
            return;
        }

        await PushNotifications.removeAllListeners();
        console.log("4. listeners removed");

        await PushNotifications.addListener('registration', async (token) => {
            console.log("5. TOKEN MILA:", token.value);
            const param = { id: 0, publicUserId: authentication.data.id, fcmToken: token.value };
            console.log("6. backend param:", JSON.stringify(param));
            const resp = await pushTokenSaveToken(param);
            console.log("7. backend response:", JSON.stringify(resp));
        });

        await PushNotifications.addListener('registrationError', (err) => {
            console.log("REGISTRATION ERROR:", JSON.stringify(err));
        });

        await PushNotifications.register();
        console.log("7. register() called");
    };
    const handleRegisterDoctor = async () => {
        if (!Capacitor.isNativePlatform()) return;

        const perm = await PushNotifications.requestPermissions();
        if (perm.receive !== 'granted') return;

        // duplicate listeners se bachne ke liye
        await PushNotifications.removeAllListeners();

        // listener PEHLE lagayein
        await PushNotifications.addListener('registration', async (token) => {
            const param = {
                id: 0,
                doctorUserId: "",
                fcmToken: token.value
            };
            await pushTokenSaveTokenDoctor(param);
        });

        await PushNotifications.addListener('registrationError', (err) => {
            console.error('Push registration error:', err.error);
        });

        await PushNotifications.addListener('pushNotificationActionPerformed', (notification) => {
            const route = notification.notification.data?.route;
            if (route) navigate(route);
        });

        // listener lagne ke BAAD register karein
        await PushNotifications.register();
    };
    return {
        handleRegister,
        handleRegisterDoctor
    }
}

export default useRegisterPush